import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'bootstrap/js/dist/collapse.js';
import 'bootstrap/js/dist/modal.js';
import 'video.js/dist/video-js.css';
import './src/style-general.scss';
import { Main } from './src/main';

new Main();
